import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen, ContentRoute } from "../../../../_metronic/layout";
import { ObjectEdit } from "../../../../_metronic/layout/components/basePage/pages/object-edit/ObjectEdit";
import ObjectsPage from "../../../../_metronic/layout/components/basePage/pages/ObjectsPage";
import { FilterObjectsUIProvider } from "../../../../_metronic/layout/components/basePage/pages/FilterObjectsUIContext";
import {
  rowFormatter,
  formFields,
  otherFields,
  initObject,
  ObjectEditSchema,
  countryColumns,
  prepareFilter,
  filterFields,
  filterInitialValues,
} from "./ManagementAuditFormReportUtils";

const ManagementCountryAuditFormReportPage = () => {
  const { currentState } = useSelector(
    (state) => ({ currentState: state.countryAuditFormReports }),
    shallowEqual
  );

  let isFullAccess = false;
  const { menuList } = useSelector(
    (state) => ({ menuList: state.auth.menu }),
    shallowEqual
  );

  if (menuList.find((q) => q.url == "/manageReportCountry")) {
    const temp = menuList.find((q) => q.url == "/manageReportCountry");
    isFullAccess = temp.isFullAccess;
  }

  return (
    <FilterObjectsUIProvider initialFilter={filterInitialValues}>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <ContentRoute
            path="/manageReportCountry"
            render={(props) => (
              <ObjectsPage
                rowFormatter={rowFormatter}
                filterByShowButton={true}
                AuditAction={false}
                haveGeneralAction={false}
                isFullAccess={isFullAccess}
                basePath="/manageReportCountry"
                api="api/AuditFormResult"
                getFunctionName="GetCountryFormResultReport"
                currentState={currentState}
                columns={countryColumns}
                prepareFilter={prepareFilter}
                filterFields={filterFields}
                filterInitialValues={filterInitialValues}
                enablePagination={false}
                haveExportButton={true}
                exportfuncName="GetExcelCountryFormResultReport2"

                haveStimulsoftReport={true}
                mrtUrl="/reports/CountryFormResultReports.mrt"
                jsonFileName="GetFormResultReport"
              />
            )}
          />
        </Switch>
      </Suspense>
    </FilterObjectsUIProvider>
  );
};

export default ManagementCountryAuditFormReportPage;
